/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
export function fmtData(d) { if (!d) return '\u2014'; const x = new Date(d); return isNaN(x) ? '\u2014' : x.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
export function fmtDataOra(d) { if (!d) return '\u2014'; const x = new Date(d); return isNaN(x) ? '\u2014' : x.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
export function fmtOra(d) { if (!d) return '\u2014'; const x = new Date(d); return isNaN(x) ? '\u2014' : x.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }); }
